export const unallocationModeOptions = {
    title: 'Unallocate Employee',
    description: 'You are about to unallocate this employee and delete the schedule from this project. Do you wish to proceed?',
    saveLabel: 'Yes',
    cancelLabel: 'No'
}

export const resetAllDialogAlertValues = {
    title: 'Reset changes',
    description: 'If you proceed with your actions, your changes will be reset.',
    saveLabel: 'Proceed',
    cancelLabel: 'Cancel'
}

export const summaryAlertValues = {
    title: 'Summary of Allocations',
    description: 'If you proceed, conflicts and/or approved budget allocations will be created and failed allocations will be discarded.',
    saveLabel: 'Proceed',
    cancelLabel: 'Cancel'
}

export const shiftMandatoryValidations = {
    errorMessage: "Shift is mandatory for Propel allocation."
}